import isEmpty from 'lodash/isEmpty'
import union from 'lodash/union'
import * as RasaInput from '../../components/rasa-input'
import * as CommunityConfig from '../community-config'
import * as Reference from '../reference'
import * as Types from './types'

export const asModalDropdown =
  (
    existingTypeId: RasaInput.DropdownKey,
    promotionTypes: Reference.ReferenceData[] = [],
  ): RasaInput.DropdownOption[] => {
  const optionalNewType = (existingTypeId > 0) ? [] : [
    {
      description: 'Select a promotion type',
      key: 0,
    },
  ]
  return [
    ...optionalNewType,
    ...promotionTypes.map((pt: Reference.ReferenceData) => ({
      description: pt.description,
      key: pt.id,
    })),
  ]
}

export const dateRangeValid = (state: Types.ModalData): boolean => {
  if ( (RasaInput.validateDate(state.start_date).invalid)
    || (RasaInput.validateDate(state.end_date).invalid) ) { return false }
  return true
}
export const modalStateValid = (state: Types.ModalData): boolean => {
  if ( (RasaInput.validateNumber(state.promotion_type_id).invalid)
    || (RasaInput.validateForgivingUrl(state.target_url).invalid)
    || (RasaInput.validateForgivingUrl(state.image_url).invalid)
    || (RasaInput.validateDate(state.start_date).invalid)
    || (RasaInput.validateDate(state.end_date).invalid)
    || (RasaInput.validateTitle(state.title).invalid) ) { return false }
  return true
}

const availablePromotions =
  (templateData: Reference.ReferenceData[], configs: CommunityConfig.CommunityConfigs): Reference.ReferenceData[] => {
  const communityTemplates = configs
    .filter((c: CommunityConfig.EditableConfigRow) => c.data.key === 'email_template')
    .map((c: CommunityConfig.EditableConfigRow) => c.data.value)
  return templateData.filter((t: Reference.ReferenceData) => communityTemplates.indexOf(t.name) >= 0)
}

export const templatePromotions =
  (templateData: Reference.ReferenceData[], configs: CommunityConfig.CommunityConfigs): string[] => {

  const allPromotions = availablePromotions(templateData, configs).map((t: Reference.ReferenceData) =>
    isEmpty(t.children) ?
      t.description.split('|') :
      t.children.map((r: Reference.TemplatePromotionData) => r.count > 0 ?
                                                               `${r.description} x${r.count}` :
                                                               `${r.description} - Unlimited`))
  return union(...allPromotions).sort()
}

export const validateSelectedPromotion = (
  selectedId: RasaInput.DropdownKey,
  templateData: Reference.ReferenceData[],
  configs: CommunityConfig.CommunityConfigs,
): RasaInput.Validation => {
  const selectedPromotion =  availablePromotions(templateData, configs)
    .filter((t: Reference.ReferenceData) => {
        return isEmpty(t.children) ||
          t.children.filter((p: Reference.TemplatePromotionData) =>
            p.id === (typeof(selectedId) === 'string' ? parseInt(selectedId, 10) : selectedId)).length > 0})
  return selectedPromotion.length > 0 ? RasaInput.validValidation : RasaInput.missingValidation
}



// WEBPACK FOOTER //
// ./src/pages/promotions/utils.ts